export class SetSearchBarStatus {
    public static readonly type = "[Projects] Set search bar status";

    constructor(public payload: boolean) {}
}
